import React from 'react';

const SatelliteAlt = () => (
  <svg width="41px" height="43px" viewBox="0 0 41 43" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs />
    <g id="Extended-trials" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Fishtrack-Funnel---extended-trials" transform="translate(-846.000000, -316.000000)">
        <rect fill="#FFFFFF" x="0" y="0" width="1440" height="909" />
        <g id="FT/satelite" transform="translate(847.000000, 316.000000)" strokeWidth="1.5">
          <path d="M35.3027685,12.8494305 L25.7203343,4.02224379 L14.3085574,16.8170556 L23.8907508,25.6442393 L35.3027685,12.8494305 Z" id="Stroke-1" stroke="#011D38" />
          <path d="M10.0867053,22.557693 L18.5270387,30.3320288 C19.3026803,27.9259414 18.557558,25.1013108 16.4356112,23.3994374 C14.5138129,21.8578872 11.9763216,21.6801714 10.0867053,22.557693 Z" id="Stroke-2" stroke="#011D38" />
          <path d="M19.3131656,39.8098077 C16.0318411,42.1636923 9.87131126,43.1014231 4.89541722,39.1103462 C-0.150410596,35.0635385 -1.02272848,28.2538846 1.50283444,23.4053077" id="Stroke-4" stroke="#67D3DF" />
          <path d="M17.1023841,35.7603077 C15.0043709,37.2655769 11.0645033,37.8651538 7.88198675,35.3131154 C4.65523179,32.725 4.09735099,28.3693846 5.71245033,25.2683846" id="Stroke-6" stroke="#67D3DF" />
          <path d="M14.4502781,31.9087731 C13.5376954,32.5640808 11.824053,32.8244269 10.4410066,31.7146577 C9.03703311,30.5895423 8.79517881,28.6946962 9.49716556,27.3471962" id="Stroke-8" stroke="#67D3DF" />
          <path d="M35.5825188,17.9932377 L28.9542111,25.4259974 L32.0917211,28.3166097 L38.7206902,20.8841168 L35.5825188,17.9932377 Z" id="Stroke-10" stroke="#011D38" />
          <path d="M13.927104,11.5810302 L20.5567178,4.14835479 L17.4177442,1.25805647 L10.7898315,8.69065547 L13.927104,11.5810302 Z" id="Stroke-12" stroke="#011D38" />
        </g>
      </g>
    </g>
  </svg>
);

export default SatelliteAlt;
